import React from 'react'

const CampaignHirePage = () => {
  return (
    <div>CampaignHirePage</div>
  )
}

export default CampaignHirePage;